module.exports = __webpack_public_path__ + "static/media/partners_list.3094a85c.png";